import { LOCATION_CHANGE } from 'redux-first-history';
import { resetProgress } from 'containers/App/actions/ui';

// Manually reset progressbar on route change
export const routeChange = ({ dispatch }) => (next) => (action) => {
  if (action.type && action.type === LOCATION_CHANGE) {
    dispatch(resetProgress());
  }
  return next(action);
};
